import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#F1511B",
			d: "M7.6 7.6H0V0h7.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#80CC28",
			d: "M16 7.6H8.4V0H16z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#00ADEF",
			d: "M7.6 16H0V8.4h7.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FBBC09",
			d: "M16 16H8.4V8.4H16z"
		})
	]
});
export { SvgMicrosoftLogo as ReactComponent };
